import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ServerConn } from '../serverConn.service';

@Injectable()
export class DocsService {

    data: any[] = [];
    doc: any;
    getting = false;

    constructor(
        private http: HttpClient,
        public server: ServerConn
    ) { }

    /**
     * Devolvemos un documento o una lista de ellos...
     *
     * @param id Documento a obtener, si no se especifica se obtienen todos.
     */
    get(id?): Observable<any> {

      let url = 'docs';

      if (typeof id !== 'undefined') {
          url += '/' + id;
      }

      return Observable.create(observer => {
          this.server.get(
              url
          ).subscribe(
              (res: any) => {
                  console.log(res);
                  if (typeof id !== 'undefined') {
                      this.doc = res.data;
                  } else {
                      this.data = JSON.parse(JSON.stringify(res.data));
                      console.log(this.data);
                  }

                  observer.next(res);
              }, // simply passing success response
              err => { // error handling
                     observer.error(err); // passing error to the method which invoked request
              },
              () => observer.complete // passing onComplete event);
          );
      });

    }

    /**
     * Grabamos un documento nuevo...
     *
     * @param doc Documento a insertar.
     */
    add(doc): Observable<any> {

      const url = 'docs/add';

      return Observable.create(observer => {
          this.server.put(
              url,
              {
                  d: doc
              }
          ).subscribe(
              (res: any) => {
                  observer.next(res);
              }, // simply passing success response
              err => { // error handling
                     observer.error(err); // passing error to the method which invoked request
              },
              () => observer.complete // passing onComplete event);
          );
      });

    }

    /**
     * Actualizamos un documento
     *
     * @param doc Documento a actualizar.
     */
    post(doc): Observable<any> {

      const url = 'docs/update';

      return Observable.create(observer => {
          this.server.post(
              url,
              {
                  d: doc
              }
          ).subscribe(
              (res: any) => {
                  observer.next(res);
              }, // simply passing success response
              err => { // error handling
                     observer.error(err); // passing error to the method which invoked request
              },
              () => observer.complete // passing onComplete event);
          );
      });

    }

    /**
     * Compartimos un documento
     *
     * @param doc Documento a actualizar.
     */
    share(doc, user): Observable<any> {

      const url = 'docs/share';

      return this.server.post(
        url,
        {
          r: doc.id,
          user: user
        }
      );

    }

    /**
     * Eliminamos un documento
     *
     * @param doc Documento a eliminar.
     */
    delete(doc): Observable<any> {

      const url = 'docs/delete/' + doc.id;

      return Observable.create(observer => {
          this.server.delete(
              url
          ).subscribe(
              (res: any) => {
                  observer.next(res);
              }, // simply passing success response
              err => { // error handling
                     observer.error(err); // passing error to the method which invoked request
              },
              () => observer.complete // passing onComplete event);
          );
      });

    }

    /**
     * Obtenemos los tipos de documentos
     */
    getTypes(): Observable<any> {

      const url = 'docs/types';

      return Observable.create(observer => {
          this.server.get(
              url
          ).subscribe(
              (res: any) => {
                  observer.next(res);
              }, // simply passing success response
              err => { // error handling
                     observer.error(err); // passing error to the method which invoked request
              },
              () => observer.complete // passing onComplete event);
          );
      });

    }

}
